<template>
  <view>
    <cube-button bindclick="show">content-popup</cube-button>
    <cube-popup
      wx:ref="popup"
      maskClosable="{{ true }}"
      content="<i style='color:#fc9153'>Hello World</i>"
      class="cube-extend-popup"
      maskFadeTransition="{{ true }}"
      transition="move-center"
      styleConfig="{{ styleConfig }}"
    >
    </cube-popup>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  data: {
    pos: '',
    trans: '',
    styleConfig: {
      mask: {
        backgroundColor: 'red',
        visibleOpacity: 0.6
      }
    }
  },
  methods: {
    show() {
      this.$refs.popup.show()
    }
  }
})
</script>

<style lang="stylus">
.cube-extend-popup
  .cube-popup-content
    padding: 20px
    color: #fff
    background-color: rgba(0, 0, 0, .8)
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-popup": "@mpxjs/mpx-cube-ui/src/components/popup/index"
    }
  }
</script>
